export default function AppSection() {
  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            移动端入口
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            随时随地参与每日大赛，手机端创作投稿更便捷
          </p>

          <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 mb-3">
                每日大赛移动版
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-5">
                下载每日大赛移动客户端，拍照即传，随时参赛。推送通知不错过每日新话题，随时随地查看榜单动态和社区互动。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  App Store
                </a>
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 font-medium text-sm rounded-lg hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-google-play-fill text-lg"></i>
                  Google Play
                </a>
              </div>
            </div>
            <div className="w-48 md:w-56 flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20creative%20content%20platform%20app%20interface%2C%20clean%20minimal%20design%2C%20warm%20color%20scheme%2C%20user%20profile%20and%20content%20feed%20visible%2C%20isolated%20on%20clean%20background%2C%20product%20photography%20style%2C%20soft%20lighting&width=400&height=800&seq=app-mockup-01&orientation=portrait"
                alt="每日大赛移动端应用界面"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}